import React from 'react';
import { Trophy, Clock, Target } from 'lucide-react';

interface PrayerMedalProps {
  isGoalMet: boolean;
  actualDuration: number;
  dailyGoal: number;
  size?: 'sm' | 'md' | 'lg';
  showDetails?: boolean;
}

const PrayerMedal: React.FC<PrayerMedalProps> = ({
  isGoalMet,
  actualDuration,
  dailyGoal,
  size = 'md',
  showDetails = false
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return {
          container: 'px-2 py-1 text-xs',
          icon: 12,
          text: 'text-xs'
        };
      case 'md':
        return {
          container: 'px-3 py-1.5 text-sm',
          icon: 14,
          text: 'text-sm'
        };
      case 'lg':
        return {
          container: 'px-4 py-2 text-base',
          icon: 16,
          text: 'text-base'
        };
      default:
        return {
          container: 'px-3 py-1.5 text-sm',
          icon: 14,
          text: 'text-sm'
        };
    }
  };

  const sizeClasses = getSizeClasses();

  if (!isGoalMet) {
    return (
      <div className={`inline-flex items-center gap-1 ${sizeClasses.container} bg-slate-100 text-slate-600 rounded-full border border-slate-200`}>
        <Clock size={sizeClasses.icon} />
        <span className={sizeClasses.text}>
          {actualDuration}분
        </span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-1 ${sizeClasses.container} bg-gradient-to-r from-yellow-400 to-orange-500 text-white rounded-full shadow-lg border border-yellow-300 animate-pulse`}>
      <Trophy size={sizeClasses.icon} />
      <span className={`${sizeClasses.text} font-semibold`}>
        {dailyGoal}분 기도완료!
      </span>
    </div>
  );
};

export default PrayerMedal;
